const config = {
    apiBaseUrl: 'http://stg-api.tretaderma.com',
};

export default config;